import { useState, useEffect } from 'react';
import { latestUpdateService } from '../services/apiService';
import LatestUpdateList from '../components/LatestUpdateList';

const LatestUpdates = () => {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchUpdates = async () => {
    try {
      setLoading(true);
      const data = await latestUpdateService.getAllLatestUpdates();
      setUpdates(data);
    } catch (err) {
      setError(err.message || 'Failed to fetch updates');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUpdates();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading updates...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Announcements Management</h2>
      <LatestUpdateList updates={updates} fetchUpdates={fetchUpdates} />
    </div>
  );
};

export default LatestUpdates;